import * as Yup from "yup";

export enum IBoxitFieldType {
  TEXT = "text",
  DATE = "date",
  SELECT = "select",
  RADIO = "radio",
  CHECKBOX = "checkbox",
}

export interface IBoxitFilterFieldConfig {
  type: IBoxitFieldType;
  name: string;
  label: string;
  placeholder?: string;
  options?: Array<{ value: string; label: string }>;
  validationSchema: Yup.AnySchema;
  testId?: string;
  isQuery?: boolean;
}

export interface IBoxitFilterProps {
  filterFields: IBoxitFilterFieldConfig[];
  onFiltersChange: (
    filters: Record<string, string | null>,
    filterQueries?: IFilterQuery[]
  ) => void;
  filterQueries?: IFilterQuery[];
  onReset: () => void;
  onCancelModal: () => void;
  isResetDatePicker?: boolean;
  dateFormat?: string;
}

export interface IFilterQuery {
  fieldName: string;
  query: FilterQueryTypes;
}

export enum FilterQueryTypes {
  LESS_THAN_OR_EQUAL = "$lte",
  EQUAL = "equal",
  GREATER_THAN_OR_EQUAL = "$gte",
}
